// ═══════════════════════════════════════════════════════════════════════════════
// Maintenance break-glass SPA path (sync with MAINTENANCE_BREAK_GLASS_PATH)
// ═══════════════════════════════════════════════════════════════════════════════

const DEFAULT_BREAK_GLASS_PATH = '/hfs-admin-main-lock';

export const getMaintenanceBreakGlassPath = (): string => {
  const fromEnv =
    typeof import.meta.env.VITE_MAINTENANCE_BREAK_GLASS_PATH === 'string'
      ? import.meta.env.VITE_MAINTENANCE_BREAK_GLASS_PATH.trim()
      : '';
  const raw = fromEnv || DEFAULT_BREAK_GLASS_PATH;
  const withSlash = raw.startsWith('/') ? raw : `/${raw}`;
  return withSlash.replace(/\/+$/, '') || DEFAULT_BREAK_GLASS_PATH;
};

export const isMaintenanceBreakGlassPath = (pathname: string): boolean => {
  const base = getMaintenanceBreakGlassPath();
  return pathname === base || pathname.startsWith(`${base}/`);
};
